import React from 'react';
import { formatEnrolledAt } from '../../../utils/formatDate';
import './StudentIdCard.css';

const getInitials = (name) => {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

const StudentIdCard = React.forwardRef(({ enrollment }, ref) => {
  if (!enrollment) {
    return <div ref={ref} className="student-id-card-root" aria-hidden="true" />;
  }

  const { date } = formatEnrolledAt(enrollment.enrolled_at);
  const initials = getInitials(enrollment.name);
  const validYear = new Date(enrollment.enrolled_at).getFullYear();

  return (
    <div ref={ref} className="student-id-card-root">
      <div
        className="student-id-card"
        style={{
          background: 'linear-gradient(135deg, #0f0f1a 0%, #1a1024 45%, #2a0f14 100%)',
          color: '#ffffff',
        }}
      >
        <div className="student-id-card__glow" aria-hidden="true" />
        <div className="student-id-card__slash" aria-hidden="true" />

        <div className="student-id-card__header">
          <div className="student-id-card__brand">
            <span className="student-id-card__brand-mark">A</span>
            <div>
              <p className="student-id-card__brand-name">Arvix Creative</p>
              <p className="student-id-card__brand-tag">Design Academy</p>
            </div>
          </div>
          <div className="student-id-card__program-badge">Creative Samurai</div>
        </div>

        <div className="student-id-card__body">
          <div className="student-id-card__avatar" aria-hidden="true">
            <span>{initials}</span>
            <div className="student-id-card__avatar-ring" />
          </div>

          <div className="student-id-card__details">
            <p className="student-id-card__label">Student Name</p>
            <p className="student-id-card__name">{enrollment.name}</p>

            <div className="student-id-card__meta-grid">
              <div>
                <p className="student-id-card__label">Student ID</p>
                <p className="student-id-card__id">{enrollment.student_id || '-'}</p>
              </div>
              <div>
                <p className="student-id-card__label">Level</p>
                <p className="student-id-card__value">{enrollment.level}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="student-id-card__footer">
          <div>
            <p className="student-id-card__label">Enrolled</p>
            <p className="student-id-card__value">{date}</p>
          </div>
          <div className="student-id-card__footer-center">
            <div className="student-id-card__chip">
              <span className="student-id-card__chip-dot" />
              Verified Member
            </div>
          </div>
          <div className="student-id-card__footer-right">
            <p className="student-id-card__label">Valid</p>
            <p className="student-id-card__value">{validYear}</p>
          </div>
        </div>

        <div className="student-id-card__pattern" aria-hidden="true">
          {Array.from({ length: 28 }).map((_, i) => (
            <span key={i} className={i % 3 === 0 ? 'student-id-card__pattern-bar--accent' : ''} />
          ))}
        </div>
      </div>
    </div>
  );
});

StudentIdCard.displayName = 'StudentIdCard';

export default StudentIdCard;
